@if (data.breadcrumb && isDesktop) {
  <nscf-breadcrumb [data]="data.breadcrumb" [isDesktop]="isDesktop"></nscf-breadcrumb>
}
<div class="mt-[-30px] bg-midnight-blue overflow-hidden slg:mt-[-80px]">
  <nscf-top-page-categorie [data]="data.topPage"></nscf-top-page-categorie>
</div>
<div #mainContent></div>
@if (data.breadcrumb && !isDesktop) {
  <nscf-breadcrumb [data]="data.breadcrumb" [isDesktop]="isDesktop"></nscf-breadcrumb>
}
